export function GridFourDotsIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8763 3.06958C11.2448 3.02362 11.6199 3 12 3C12.3801 3 12.7552 3.02362 13.1237 3.06958L12.8763 5.05421C12.5896 5.01846 12.2972 5 12 5C11.7028 5 11.4104 5.01846 11.1237 5.05421L10.8763 3.06958ZM3 12C3 11.6199 3.02362 11.2448 3.06958 10.8763L5.05421 11.1237C5.01846 11.4104 5 11.7028 5 12C5 12.2972 5.01846 12.5896 5.05421 12.8763L3.06958 13.1237C3.02362 12.7552 3 12.3801 3 12ZM19 12C19 11.7028 18.9815 11.4104 18.9458 11.1237L20.9304 10.8763C20.9764 11.2448 21 11.6199 21 12C21 12.3801 20.9764 12.7552 20.9304 13.1237L18.9458 12.8763C18.9815 12.5896 19 12.2972 19 12ZM11.1237 18.9458C11.4104 18.9815 11.7028 19 12 19C12.2972 19 12.5896 18.9815 12.8763 18.9458L13.1237 20.9304C12.7552 20.9764 12.3801 21 12 21C11.6199 21 11.2448 20.9764 10.8763 20.9304L11.1237 18.9458Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 5C5.67157 5 5 5.67157 5 6.5C5 7.32843 5.67157 8 6.5 8C7.32843 8 8 7.32843 8 6.5C8 5.67157 7.32843 5 6.5 5ZM3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 16C5.67157 16 5 16.6716 5 17.5C5 18.3284 5.67157 19 6.5 19C7.32843 19 8 18.3284 8 17.5C8 16.6716 7.32843 16 6.5 16ZM3 17.5C3 15.567 4.567 14 6.5 14C8.433 14 10 15.567 10 17.5C10 19.433 8.433 21 6.5 21C4.567 21 3 19.433 3 17.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 16C16.6716 16 16 16.6716 16 17.5C16 18.3284 16.6716 19 17.5 19C18.3284 19 19 18.3284 19 17.5C19 16.6716 18.3284 16 17.5 16ZM14 17.5C14 15.567 15.567 14 17.5 14C19.433 14 21 15.567 21 17.5C21 19.433 19.433 21 17.5 21C15.567 21 14 19.433 14 17.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 5C16.6716 5 16 5.67157 16 6.5C16 7.32843 16.6716 8 17.5 8C18.3284 8 19 7.32843 19 6.5C19 5.67157 18.3284 5 17.5 5ZM14 6.5C14 4.567 15.567 3 17.5 3C19.433 3 21 4.567 21 6.5C21 8.433 19.433 10 17.5 10C15.567 10 14 8.433 14 6.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
